export default __webpack_public_path__ + "static/media/logo_black.d6c8fb9e.png";